import { createContext, JSX, useReducer } from "react";
import { AppState, initialAppState } from "../state/state";
import { ActionTypes, AppActions } from "../actions/actions";

export const AppContext = createContext<{
    state: AppState;
    dispatch: React.Dispatch<AppActions>;
}>({
    state: initialAppState,
    dispatch: () => undefined,
});

export default function AppContextProvider(props: { children: JSX.Element }) {
    const { children } = props;
    const [state, dispatch] = useReducer(reducer, initialAppState);

    return <>
        <AppContext.Provider value={{ state, dispatch }}>
            {children}
        </AppContext.Provider>
    </>
}

function reducer(state: AppState, action: AppActions): AppState {
    switch (action.type) {
        case ActionTypes.ChangeCategory:
            return {
                ...state,
                selectedCategory: action.payload
            }

        case ActionTypes.SetDocs:
            return {
                ...state,
                docs: {
                    loaded: true,
                    items: action.payload
                }
            }

        case ActionTypes.SetProduct:
            return { ...state, product: action.payload }

        case ActionTypes.SetSpecificDoc:
            const updatedDocs = state.docs.items.map(doc => doc._id === action.payload._id ? action.payload : doc)
            return {
                ...state,
                docs: {
                    ...state.docs,
                    items: updatedDocs
                }
            }

        case ActionTypes.SetProductProp:
            return {
                ...state,
                product: {
                    ...state.product,
                    [action.propName]: action.propValue,
                }
            }
        default:
            throw new Error("Undefined action");
    }
}